/** The view-gap between a block and the one below it lives on the block's
 *  own top-level `gap` field (see BlockModel) - applies downward, not a
 *  separate block. Only written when it differs from the default. */
export const GAP_DEFAULT_SIZE = '20';
